import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { AttachmentPosition } from "../../../../../../../services/application.common.model";
import { ApplicationAppEntityApplicationRead } from "../../../../../../../openapi";

@Component({
  selector: 'app-template-view',
  standalone: true,
  imports: [],
  templateUrl: './template-view.component.html'
})
export class TemplateViewComponent {

  private allowedUrls: string[] = [
    '/decyzja-o-warunkach-zabudowy',
    '/decyzja-o-ustalenie-lokalizacji-inwestycji-celu-publicznego'
  ];

  public attachmentPosition: InputSignal<AttachmentPosition | null> = input<AttachmentPosition | null>(null);

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public get displayTemplate(): Signal<boolean> {
    return computed(() => this.allowedUrls.includes(this.application()?.service?.url || ''))
  }


}
